(() => {
  const root = document.documentElement;
  const body = document.body;
  const T = window.vmTheme || { routes: {} };

  const formatMoney = (cents) => {
    const fmt = T.moneyFormat || '€{{amount_with_comma_separator}}';
    const value = (cents / 100).toFixed(2);
    const [int, dec] = value.split('.');
    const withSep = (s, sep) => s.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
      if (key === 'amount_with_comma_separator') return withSep(int, '.') + ',' + dec;
      if (key === 'amount_no_decimals_with_comma_separator') return withSep(int, '.');
      if (key === 'amount_no_decimals') return withSep(int, ',');
      return withSep(int, ',') + '.' + dec;
    });
  };

  const scrollLock = (on) => {
    if (on) { body.style.overflow = 'hidden'; body.style.paddingRight = '0px'; body.setAttribute('data-scroll-locked', ''); }
    else { body.style.overflow = ''; body.style.paddingRight = ''; body.removeAttribute('data-scroll-locked'); }
  };

  const setHeights = () => {
    const h = window.innerHeight;
    const header = document.querySelector('.theme__header');
    const footer = document.querySelector('.footer-sections .site-footer-wrapper') || document.querySelector('.footer-sections');
    const headerH = header ? header.offsetHeight : 0;
    root.style.setProperty('--scrollbar-width', '0px');
    root.style.setProperty('--full-height', h + 'px');
    root.style.setProperty('--three-quarters', h * 0.75 + 'px');
    root.style.setProperty('--two-thirds', h * 2 / 3 + 'px');
    root.style.setProperty('--one-half', h / 2 + 'px');
    root.style.setProperty('--one-third', h / 3 + 'px');
    root.style.setProperty('--one-fifth', h / 5 + 'px');
    root.style.setProperty('--collection-nav-height', '0px');
    root.style.setProperty('--header-height', headerH + 'px');
    if (footer) root.style.setProperty('--footer-height', footer.offsetHeight + 'px');
    root.style.setProperty('--content-full', (h - headerH) + 'px');
    root.style.setProperty('--content-min', (h - headerH - (footer ? footer.offsetHeight : 0)) + 'px');
  };

  const aosPending = new Set();
  const aosCheck = () => {
    const limit = window.innerHeight - 40;
    aosPending.forEach((anchor) => {
      if (anchor.getBoundingClientRect().top < limit) {
        (anchor.__aosTargets || []).forEach((e) => e.classList.add('aos-animate'));
        aosPending.delete(anchor);
      }
    });
  };
  const initAos = () => {
    body.classList.add('aos-initialized', 'is-loaded');
    document.querySelectorAll('[data-aos]:not(.aos-animate)').forEach((e) => {
      let anchor = e;
      const sel = e.getAttribute('data-aos-anchor');
      if (sel) { try { anchor = document.querySelector(sel.startsWith('#') ? sel : '#' + sel) || e; } catch (err) { anchor = e; } }
      anchor.__aosTargets = anchor.__aosTargets || [];
      if (!anchor.__aosTargets.includes(e)) anchor.__aosTargets.push(e);
      aosPending.add(anchor);
    });
    aosCheck();
  };
  let aosTick = false;
  window.addEventListener('scroll', () => { if (aosTick) return; aosTick = true; requestAnimationFrame(() => { aosTick = false; aosCheck(); }); }, { passive: true });
  window.addEventListener('resize', aosCheck);

  const initStickyHeader = () => {
    const wrap = document.querySelector('header-component[data-header-sticky]');
    if (!wrap) return;
    const section = wrap.closest('.shopify-section');
    const update = () => {
      const top = section ? section.getBoundingClientRect().top + window.scrollY : 0;
      wrap.classList.toggle('js__header__stuck', window.scrollY > top);
    };
    window.addEventListener('scroll', update, { passive: true });
    update();
  };

  const initMegaMenu = () => {
    document.querySelectorAll('hover-disclosure').forEach((item) => {
      const wrap = item.closest('header-component');
      const dropdown = item.querySelector('.header__dropdown');
      let timer;
      const open = () => {
        clearTimeout(timer);
        document.querySelectorAll('hover-disclosure.is-visible').forEach((o) => { if (o !== item) close(o, true); });
        item.classList.add('is-visible'); item.setAttribute('aria-expanded', 'true');
        if (dropdown) dropdown.classList.add('is-visible');
        if (wrap) wrap.classList.add('meganav--visible');
      };
      const close = (el = item, now = false) => {
        const run = () => {
          el.classList.remove('is-visible'); el.setAttribute('aria-expanded', 'false');
          const d = el.querySelector('.header__dropdown');
          if (d) d.classList.remove('is-visible');
          if (wrap && !document.querySelector('hover-disclosure.is-visible')) wrap.classList.remove('meganav--visible');
        };
        if (now) run(); else timer = setTimeout(run, 100);
      };
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', () => close());
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) close(); });
    });
  };

  const initPredictive = (holder) => {
    const input = holder.querySelector('input[type="search"]');
    const comp = holder.querySelector('predictive-search');
    const results = holder.querySelector('[data-predictive-search-results]');
    const reset = holder.querySelector('.search-reset');
    const form = holder.querySelector('form.search-form');
    if (!input || !results || !comp) return;
    const loading = results.innerHTML;
    let ctrl;
    const setHeight = () => {
      const top = results.getBoundingClientRect().top;
      results.style.setProperty('--results-height', Math.max(0, window.innerHeight - top) + 'px');
    };
    const run = async () => {
      const q = input.value.trim();
      reset && reset.classList.toggle('hidden', !q);
      if (!q) { comp.removeAttribute('open'); comp.removeAttribute('loading'); input.setAttribute('aria-expanded', 'false'); return; }
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      comp.setAttribute('loading', 'true');
      try {
        const r = await fetch(`${T.routes.predictiveSearch}?q=${encodeURIComponent(q)}&section_id=vm-predictive-search&resources[limit]=8&resources[type]=product,collection,query`, { signal: ctrl.signal });
        const html = await r.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('#shopify-section-vm-predictive-search');
        results.innerHTML = (inner ? inner.innerHTML : '') || loading;
        comp.setAttribute('open', 'true');
        input.setAttribute('aria-expanded', 'true');
        setHeight();
        requestAnimationFrame(() => results.querySelectorAll('[data-aos]').forEach((e) => e.classList.add('aos-animate')));
        results.querySelector('[data-predictive-search-all]')?.addEventListener('click', () => form.submit());
        initHoverImages();
      } catch (e) { if (e.name !== 'AbortError') comp.removeAttribute('open'); }
      comp.removeAttribute('loading');
    };
    let t;
    input.addEventListener('input', () => { clearTimeout(t); t = setTimeout(run, 250); });
    reset && reset.addEventListener('click', () => { setTimeout(run, 0); input.focus(); });
    window.addEventListener('resize', () => { if (comp.hasAttribute('open')) setHeight(); });
  };

  const initSearch = () => {
    document.querySelectorAll('header-search-popdown').forEach((pop) => {
      const details = pop.querySelector('details');
      const summary = pop.querySelector('summary');
      const close = () => { details.removeAttribute('open'); pop.classList.remove('is-open'); scrollLock(false); };
      summary.addEventListener('click', (e) => {
        e.preventDefault();
        if (details.hasAttribute('open')) { close(); return; }
        details.setAttribute('open', ''); pop.classList.add('is-open'); scrollLock(true);
        setTimeout(() => pop.querySelector('input[type="search"]')?.focus(), 50);
      });
      pop.querySelector('[data-popdown-close]')?.addEventListener('click', close);
      pop.querySelector('[data-popdown-underlay]')?.addEventListener('click', close);
      document.addEventListener('keyup', (e) => { if (e.key === 'Escape' && details.hasAttribute('open')) close(); });
      initPredictive(pop);
    });
  };

  const animateIn = (container) => {
    container.querySelectorAll('[data-animation]').forEach((e) => { e.classList.remove('is-hiding'); e.classList.add('is-animated'); });
  };
  const animateOut = (container) => {
    container.querySelectorAll('[data-animation]').forEach((e) => e.classList.remove('is-animated'));
  };

  const initMobileMenu = () => {
    const drawer = document.querySelector('mobile-menu header-drawer') || document.querySelector('header-drawer');
    if (!drawer) return;
    const nav = drawer.querySelector('[data-sliderule-pane]');
    const open = () => {
      drawer.classList.add('is-open', 'drawer--animated');
      animateIn(drawer);
      scrollLock(true);
      document.querySelectorAll('[data-drawer-toggle="hamburger"]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
    };
    const close = () => {
      drawer.classList.remove('is-open');
      scrollLock(false);
      document.querySelectorAll('[data-drawer-toggle="hamburger"]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
      setTimeout(() => {
        if (drawer.classList.contains('is-open')) return;
        drawer.classList.remove('drawer--animated');
        animateOut(drawer);
        drawer.querySelectorAll('.sliderule__panel.is-visible').forEach((p) => p.classList.remove('is-visible'));
        drawer.querySelectorAll('.sliderow.is-hidden').forEach((r) => r.classList.remove('is-hidden'));
        drawer.querySelectorAll('[data-sliderule-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
        if (nav) nav.setAttribute('data-sliderule-pane', '0');
      }, 400);
    };
    document.querySelectorAll('[data-drawer-toggle="hamburger"]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); drawer.classList.contains('is-open') ? close() : open(); }));
    drawer.querySelectorAll('[data-drawer-close], [data-drawer-underlay]').forEach((b) => b.addEventListener('click', close));
    document.addEventListener('keyup', (e) => { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });
    const levelRows = (rule) => {
      const container = rule.parentElement.closest('[data-links]') || drawer.querySelector('.drawer__main-menu');
      return [...container.querySelectorAll(':scope > .sliderule__wrapper > .sliderow, :scope > .sliderule__wrapper > mobile-sliderule > .sliderow')];
    };
    drawer.querySelectorAll('[data-sliderule-open]').forEach((btn) => {
      const rule = btn.closest('mobile-sliderule');
      const panel = rule.querySelector(':scope > .sliderule__panel');
      btn.addEventListener('click', () => {
        levelRows(rule).forEach((r) => r.classList.add('is-hidden'));
        panel.classList.remove('is-hiding');
        panel.classList.add('is-visible');
        btn.setAttribute('aria-expanded', 'true');
        nav.setAttribute('data-sliderule-pane', panel.getAttribute('data-sliderule'));
      });
      panel.querySelector(':scope > .sliderow--back [data-sliderule-close]')?.addEventListener('click', () => {
        const depth = Number(panel.getAttribute('data-sliderule')) - 1;
        nav.classList.add('is-hiding');
        panel.classList.add('is-hiding');
        levelRows(rule).forEach((r) => r.classList.remove('is-hidden'));
        nav.setAttribute('data-sliderule-pane', String(depth));
        btn.setAttribute('aria-expanded', 'false');
        setTimeout(() => { nav.classList.remove('is-hiding'); panel.classList.remove('is-hiding', 'is-visible'); }, 500);
      });
    });
  };

  const initCollapsibles = (scope = document) => {
    scope.querySelectorAll('details[data-collapsible]').forEach((d) => {
      if (d.__vm) return; d.__vm = true;
      if (d.hasAttribute('disabled')) {
        d.querySelector('summary')?.addEventListener('click', (e) => { if (window.innerWidth >= 750 || d.getAttribute('mobile') === 'false') e.preventDefault(); });
        return;
      }
      const summary = d.querySelector('summary');
      const bodyEl = d.querySelector('[data-collapsible-body]');
      const group = d.closest('collapsible-elements[single="true"]');
      const animate = (from, to, done) => {
        bodyEl.style.overflow = 'hidden';
        const a = bodyEl.animate({ height: [from + 'px', to + 'px'] }, { duration: 400, easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)' });
        a.onfinish = () => { bodyEl.style.overflow = ''; bodyEl.style.height = to ? 'auto' : ''; done && done(); };
      };
      const closeIt = (el) => {
        const b = el.querySelector('[data-collapsible-body]');
        const h = b.offsetHeight;
        el.classList.remove('is-open');
        el.setAttribute('open', 'false');
        const a = b.animate({ height: [h + 'px', '0px'] }, { duration: 400, easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)' });
        b.style.overflow = 'hidden';
        b.style.height = '';
        a.onfinish = () => { el.removeAttribute('open'); b.style.overflow = ''; };
      };
      summary.addEventListener('click', (e) => {
        e.preventDefault();
        if (d.hasAttribute('open') && d.classList.contains('is-open')) { closeIt(d); return; }
        if (group) group.querySelectorAll('details[data-collapsible].is-open').forEach((o) => { if (o !== d) closeIt(o); });
        d.setAttribute('open', 'true');
        d.classList.add('is-open');
        animate(0, bodyEl.scrollHeight);
      });
      if (d.hasAttribute('open')) { d.setAttribute('open', 'true'); d.classList.add('is-open'); bodyEl.style.height = 'auto'; }
    });
  };

  const cart = {
    drawer: () => document.querySelector('cart-drawer'),
    sectionId: () => document.querySelector('[data-section-type="cart-drawer"]')?.closest('.shopify-section')?.id.replace('shopify-section-', ''),
    open() {
      const d = this.drawer(); if (!d) { location.href = T.routes.cart; return; }
      d.classList.add('is-open');
      animateIn(d);
      scrollLock(true);
    },
    close() {
      const d = this.drawer(); if (!d) return;
      d.classList.remove('is-open');
      scrollLock(false);
      setTimeout(() => { if (!d.classList.contains('is-open')) animateOut(d); }, 400);
    },
    async refresh(openAfter) {
      const id = this.sectionId();
      const sections = [id].filter(Boolean);
      const r = await fetch(`${T.routes.root.replace(/\/$/, '')}/?sections=${sections.join(',')}`);
      const data = await r.json();
      const wasOpen = this.drawer()?.classList.contains('is-open');
      if (id && data[id]) {
        const doc = new DOMParser().parseFromString(data[id], 'text/html');
        const fresh = doc.querySelector('[data-section-type="cart-drawer"]');
        const holder = document.querySelector('[data-section-type="cart-drawer"]');
        if (fresh && holder) {
          holder.replaceWith(fresh);
          this.bind();
          const d = this.drawer();
          if (wasOpen || openAfter) { d.classList.add('is-open'); d.querySelectorAll('[data-animation]').forEach((e) => e.classList.add('is-animated')); }
        }
      }
      const count = (await (await fetch(`${T.routes.cart}.js`)).json()).item_count;
      document.querySelectorAll('.header__cart__status').forEach((c) => { c.textContent = count; c.setAttribute('data-cart-count', count); });
      document.dispatchEvent(new CustomEvent('vm:cart-updated', { detail: { count } }));
      startTimers();
      if (openAfter && !wasOpen) this.open();
    },
    async change(key, quantity) {
      const d = this.drawer();
      d?.classList.add('is-loading');
      const r = await fetch(`${T.routes.cartChange}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
      if (!r.ok) {
        const err = await r.json().catch(() => ({}));
        const box = d?.querySelector('[data-cart-errors]');
        if (box) { box.querySelector('[data-error-message]').textContent = err.description || err.message || ''; box.classList.add('is-visible'); }
      }
      await this.refresh(false);
      this.drawer()?.classList.remove('is-loading');
    },
    async add(items, button) {
      button?.classList.add('is-loading');
      const r = await fetch(`${T.routes.cartAdd}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      const json = await r.json();
      button?.classList.remove('is-loading');
      if (!r.ok) return { error: json.description || json.message };
      await this.refresh(true);
      return json;
    },
    bind() {
      const d = this.drawer(); if (!d) return;
      d.querySelectorAll('[data-cart-drawer-close], [data-drawer-underlay]').forEach((b) => b.addEventListener('click', () => this.close()));
      d.querySelector('[data-cart-error-close]')?.addEventListener('click', () => d.querySelector('[data-cart-errors]').classList.remove('is-visible'));
      d.querySelectorAll('.cart__item').forEach((item) => {
        const key = item.getAttribute('data-item');
        const field = item.querySelector('.cart__quantity-field');
        item.querySelector('[data-item-remove]')?.addEventListener('click', (e) => { e.preventDefault(); item.classList.add('is-removed'); this.change(key, 0); });
        item.querySelector('.cart__quantity-minus')?.addEventListener('click', () => this.change(key, Math.max(0, Number(field.value) - 1)));
        item.querySelector('.cart__quantity-plus')?.addEventListener('click', () => this.change(key, Number(field.value) + 1));
        field?.addEventListener('change', () => this.change(key, Math.max(0, Number(field.value) || 0)));
      });
      initPopouts(d, (popout, value) => {
        const item = popout.closest('.cart__item');
        if (!item) return;
        if (value === '10') { popout.closest('quantity-counter').classList.add('is-active'); item.querySelector('.cart__quantity-field')?.focus(); }
        this.change(item.getAttribute('data-item'), Number(value));
      });
    },
    bindPage() {
      const page = document.querySelector('[data-cart-page]');
      if (!page) return;
      const go = async (key, q) => {
        page.classList.add('is-loading');
        await fetch(`${T.routes.cartChange}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) });
        location.reload();
      };
      page.querySelectorAll('.cart__item').forEach((item) => {
        const key = item.getAttribute('data-item');
        const field = item.querySelector('.cart__quantity-field');
        item.querySelector('[data-item-remove]')?.addEventListener('click', (e) => { e.preventDefault(); go(key, 0); });
        item.querySelector('.cart__quantity-minus')?.addEventListener('click', () => go(key, Math.max(0, Number(field.value) - 1)));
        item.querySelector('.cart__quantity-plus')?.addEventListener('click', () => go(key, Number(field.value) + 1));
        field?.addEventListener('change', () => go(key, Math.max(0, Number(field.value) || 0)));
      });
      initPopouts(page, (pop, value) => { const item = pop.closest('.cart__item'); if (item) go(item.getAttribute('data-item'), Number(value)); });
      page.querySelector('#gift-note')?.addEventListener('change', (e) => fetch(`${T.routes.cart}/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Cadeau boodschap': e.target.value } }) }));
    },
    init() {
      this.bind();
      this.bindPage();
      document.addEventListener('click', (e) => {
        const t = e.target.closest('[data-cart-toggle]');
        if (t && this.drawer() && !document.querySelector('[data-cart-page]')) { e.preventDefault(); this.open(); }
      });
      document.addEventListener('keyup', (e) => { if (e.key === 'Escape' && this.drawer()?.classList.contains('is-open')) this.close(); });
    },
  };
  window.vmCart = cart;

  function initPopouts(scope, onSelect) {
    scope.querySelectorAll('popout-select').forEach((pop) => {
      if (pop.__vm) return; pop.__vm = true;
      const toggle = pop.querySelector('[data-popout-toggle]');
      const list = pop.querySelector('[data-popout-list]');
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        const open = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(open));
        list.classList.toggle('select-popout__list--visible', open); list.classList.toggle('popout-list--visible', open);
        pop.classList.toggle('is-open', open);
      });
      list.querySelectorAll('[data-popout-option]').forEach((opt) => opt.addEventListener('click', (e) => {
        e.preventDefault();
        toggle.setAttribute('aria-expanded', 'false');
        list.classList.remove('select-popout__list--visible', 'popout-list--visible');
        pop.classList.remove('is-open');
        const v = opt.getAttribute('data-value');
        const text = toggle.querySelector('[data-popout-toggle-text]');
        if (text) text.textContent = v;
        onSelect && onSelect(pop, v);
      }));
      document.addEventListener('click', (e) => {
        if (!pop.contains(e.target) && toggle.getAttribute('aria-expanded') === 'true') {
          toggle.setAttribute('aria-expanded', 'false'); list.classList.remove('select-popout__list--visible', 'popout-list--visible'); pop.classList.remove('is-open');
        }
      });
    });
  }

  let timerStart = Date.now();
  let timerInterval;
  function startTimers() {
    const els = document.querySelectorAll('[data-cart-timer]');
    if (!els.length) return;
    const minutes = Number(els[0].getAttribute('data-minutes')) || 10;
    const tick = () => {
      const left = Math.max(0, minutes * 60 - 1 - Math.floor((Date.now() - timerStart) / 1000));
      const txt = String(Math.floor(left / 60)).padStart(2, '0') + ':' + String(left % 60).padStart(2, '0');
      document.querySelectorAll('[data-cart-timer]').forEach((e) => { e.textContent = txt; });
    };
    tick();
    clearInterval(timerInterval);
    timerInterval = setInterval(tick, 1000);
  }

  const initSliders = () => {
    document.querySelectorAll('.slideshow__slider').forEach((slider) => {
      const slides = [...slider.querySelectorAll('.slideshow__slide')];
      if (slides.length < 2) return;
      let i = 0;
      const show = (n) => {
        i = (n + slides.length) % slides.length;
        slides.forEach((s, k) => s.classList.toggle('is-selected', k === i));
        slider.style.setProperty('--slide-index', i);
      };
      const speed = Number(slider.getAttribute('data-autoplay')) || 0;
      if (speed) setInterval(() => show(i + 1), speed * 1000);
      show(0);
    });
  };

  const initHoverImages = () => {
    document.querySelectorAll('hover-images').forEach((h) => {
      if (h.__vm) return; h.__vm = true;
      const item = h.closest('.product-item');
      if (!item) return;
      item.addEventListener('mouseenter', () => h.classList.add('is-active'));
      item.addEventListener('mouseleave', () => h.classList.remove('is-active'));
    });
  };

  const initTables = (scope = document) => {
    scope.querySelectorAll('.rte table').forEach((t) => {
      if (t.parentElement.classList.contains('rte__table-wrapper')) return;
      const w = document.createElement('div');
      w.className = 'rte__table-wrapper';
      t.parentNode.insertBefore(w, t);
      w.appendChild(t);
    });
  };

  const initEllipsis = (scope = document) => {
    scope.querySelectorAll('toggle-ellipsis').forEach((t) => {
      if (t.__vm) return; t.__vm = true;
      const content = t.querySelector('[data-content]');
      const limit = parseInt(t.getAttribute('data-height'), 10) || 175;
      const check = () => { if (!t.classList.contains('is-open')) t.classList.toggle('is-enabled', content.scrollHeight > limit); };
      t.querySelector('[data-button]')?.addEventListener('click', () => {
        t.classList.add('is-open');
        t.style.maxHeight = content.scrollHeight + 'px';
        const body = t.closest('[data-collapsible-body]');
        if (body) body.style.height = 'auto';
      });
      check();
      t.closest('details')?.addEventListener('toggle', check);
      new ResizeObserver(check).observe(content);
    });
  };

  const initProducts = (scope = document) => {
    scope.querySelectorAll('product-component').forEach((root) => {
      if (root.__vm) return; root.__vm = true;
      const jsonEl = root.querySelector('[data-product-json]');
      const product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
      const images = root.querySelector('product-images');
      const slides = images ? [...images.querySelectorAll('[data-slide]')] : [];
      const thumbs = images ? [...images.querySelectorAll('[data-thumb-item]')] : [];

      const showMedia = (mediaId) => {
        if (!images) return;
        const target = slides.find((s) => s.getAttribute('data-media-id') === mediaId);
        if (!target) return;
        slides.forEach((s) => { const on = s === target; s.classList.toggle('media--active', on); s.classList.toggle('media--hidden', !on); });
        thumbs.forEach((t) => { const a = t.querySelector('[data-thumb-link]'); const on = a.getAttribute('data-media-id') === mediaId; t.classList.toggle('is-active', on); a.setAttribute('aria-current', String(on)); });
        images.setAttribute('data-active-media', mediaId);
        setGalleryHeight();
      };
      function setGalleryHeight() {
        if (!images) return;
        const active = images.querySelector('.product__slide.media--active .product__photo');
        if (active && active.offsetHeight) images.style.setProperty('--height', active.offsetHeight + 'px');
      }
      setGalleryHeight();
      window.addEventListener('resize', setGalleryHeight);
      images?.querySelectorAll('img').forEach((img) => img.addEventListener('load', setGalleryHeight));
      thumbs.forEach((t) => t.querySelector('[data-thumb-link]').addEventListener('click', (e) => { e.preventDefault(); showMedia(t.querySelector('[data-thumb-link]').getAttribute('data-media-id')); }));
      const step = (d) => {
        const i = slides.findIndex((s) => s.classList.contains('media--active'));
        const n = slides[(i + d + slides.length) % slides.length];
        if (n) showMedia(n.getAttribute('data-media-id'));
      };
      root.querySelector('[data-button-prev]')?.addEventListener('click', () => step(-1));
      root.querySelector('[data-button-next]')?.addEventListener('click', () => step(1));
      let touchX = null;
      const slideList = root.querySelector('[data-product-media-list]');
      slideList?.addEventListener('touchstart', (e) => { touchX = e.touches[0].clientX; }, { passive: true });
      slideList?.addEventListener('touchend', (e) => { if (touchX === null) return; const dx = e.changedTouches[0].clientX - touchX; if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1); touchX = null; });

      if (!product) return;
      const sectionId = root.getAttribute('data-section-id');
      const idInput = root.querySelector('input[type="hidden"][name="id"]');
      const formEl = root.querySelector('form[data-product-form]');
      const button = root.querySelector('[data-add-to-cart]');
      const update = () => {
        const selected = [...root.querySelectorAll('[data-single-option-selector]:checked')].sort((a, b) => a.dataset.index.localeCompare(b.dataset.index)).map((i) => i.value);
        const variant = product.variants.find((v) => v.options.every((o, k) => o === selected[k]));
        root.querySelectorAll('.selector-wrapper').forEach((w) => {
          const checked = w.querySelector('[data-single-option-selector]:checked');
          const lbl = w.querySelector('[data-option-value]');
          if (checked && lbl) lbl.textContent = checked.value;
        });
        root.querySelectorAll('[data-single-option-selector]').forEach((inp) => {
          const pos = Number(inp.dataset.index.replace('option', '')) - 1;
          const test = selected.slice(); test[pos] = inp.value;
          const ok = product.variants.some((v) => v.available && v.options.every((o, k) => k === pos ? o === inp.value : (k < pos ? o === test[k] : true)));
          inp.classList.toggle('sold-out', !ok);
        });
        if (!variant) {
          if (button) { button.disabled = true; button.querySelector('[data-add-to-cart-text]').textContent = button.dataset.labelSold; }
          return;
        }
        if (idInput) idInput.value = variant.id;
        if (formEl) { let f = formEl.querySelector('input[name="id"]'); if (!f) { f = document.createElement('input'); f.type = 'hidden'; f.name = 'id'; formEl.appendChild(f); } f.value = variant.id; }
        const price = root.querySelector('[data-product-price]');
        const compare = root.querySelector('[data-compare-price]');
        const badge = root.querySelector('[data-price-off-badge]');
        const onSale = variant.compare_at_price > variant.price;
        if (price) { price.textContent = formatMoney(variant.price); price.classList.toggle('product__price--sale', onSale); }
        if (compare) compare.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
        if (badge) {
          badge.style.display = onSale ? '' : 'none';
          const amt = badge.querySelector('[data-price-off-amount]');
          if (amt && onSale) amt.textContent = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%';
        }
        if (button) {
          button.disabled = !variant.available;
          button.querySelector('[data-add-to-cart-text]').textContent = variant.available ? button.dataset.labelAdd : button.dataset.labelSold;
        }
        if (variant.featured_media) showMedia(sectionId + '-' + variant.featured_media.id);
        const url = new URL(location.href); url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      };
      root.querySelectorAll('[data-single-option-selector]').forEach((inp) => inp.addEventListener('change', update));
      formEl?.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (!button || button.disabled) return;
        const id = Number(formEl.querySelector('input[name="id"]')?.value || idInput.value);
        const qty = Number(formEl.querySelector('input[name="quantity"]')?.value || 1);
        const errors = root.querySelector('[data-cart-errors-container]');
        if (errors) errors.innerHTML = '';
        const r = await cart.add([{ id, quantity: qty }], button);
        if (r && r.error && errors) errors.innerHTML = `<div class="errors">${r.error}</div>`;
      });
    });
  };

  const initSearchPage = () => {
    document.querySelectorAll('.search-page, .collection').forEach((page) => {
      if (page.__vm) return; page.__vm = true;
      const toggle = page.querySelector('[data-aria-toggle]');
      const sidebar = page.querySelector('[data-collection-sidebar]');
      if (toggle && sidebar) {
        toggle.addEventListener('click', () => {
          const mobile = window.innerWidth < 750;
          if (mobile) {
            sidebar.classList.add('expanded', 'is-open'); scrollLock(true); animateIn(sidebar);
          } else {
            const open = toggle.getAttribute('aria-expanded') !== 'true';
            toggle.setAttribute('aria-expanded', String(open));
            sidebar.classList.toggle('expanded', open);
          }
        });
        page.querySelectorAll('[data-collection-sidebar-close]').forEach((c) => c.addEventListener('click', (e) => { e.preventDefault(); sidebar.classList.remove('is-open'); scrollLock(false); }));
        if (window.innerWidth < 750) { toggle.setAttribute('aria-expanded', 'false'); sidebar.classList.remove('expanded'); }
        animateIn(sidebar);
      }
      const form = page.querySelector('[data-collection-filters-form]');
      form?.addEventListener('change', () => form.submit());
      const sort = page.querySelector('[data-sort-popout]');
      if (sort) initPopouts(page, (pop, value) => {
        if (pop !== sort) return;
        const url = new URL(location.href); url.searchParams.set('sort_by', value); url.searchParams.delete('page');
        location.href = url.toString();
      });
      page.querySelectorAll('.search-form').forEach((f) => {
        const input = f.querySelector('input[type="search"]');
        const reset = f.querySelector('.search-reset');
        input?.addEventListener('input', () => reset?.classList.toggle('hidden', !input.value));
        reset?.addEventListener('click', () => setTimeout(() => { reset.classList.add('hidden'); input.focus(); }, 0));
      });
    });
  };

  window.vmInit = (scope = document) => { initTables(scope); initCollapsibles(scope); initHoverImages(); initEllipsis(scope); initProducts(scope); };

  const boot = () => {
    setHeights();
    initAos();
    initStickyHeader();
    initMegaMenu();
    initSearch();
    initMobileMenu();
    initTables();
    initCollapsibles();
    initSliders();
    initHoverImages();
    initEllipsis();
    initProducts();
    initSearchPage();
    cart.init();
    startTimers();
    window.addEventListener('resize', setHeights);
    document.addEventListener('keydown', (e) => { if (e.key === 'Tab') body.classList.add('is-focused'); });
    document.addEventListener('mousedown', () => body.classList.remove('is-focused'));
    document.addEventListener('shopify:section:load', (e) => { setHeights(); initAos(); window.vmInit(e.target); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
